var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import { expr, hasProperty, isPlainObject, isRequired, pick, round, validateHex } from './utils';

var RGB = ['r', 'g', 'b'];
var HSL = ['h', 's', 'l'];

/**
 * Colorizr
 * @class
 */

var Colorizr = function () {

  /**
   * @constructs Colorizr
   * @param {string|Array|Object} color
   */
  function Colorizr(color) {
    _classCallCheck(this, Colorizr);

    this.hex = '';
    this.hsl = {
      h: 0,
      s: 0,
      l: 0
    };
    this.rgb = {
      r: 0,
      g: 0,
      b: 0
    };

    this.setColor(color);
  }

  /**
   * Set the main color.
   *
   * @param {string|Array|Object} color
   */


  _createClass(Colorizr, [{
    key: 'setColor',
    value: function setColor(color) {
      if (!color) return;

      if (typeof color === 'string') {
        this.hex = this.parseHex(color);
        this.rgb = this.hex2rgb();
        this.hsl = this.hex2hsl();
      } else if (Array.isArray(color)) {
        this.setColorFromArray(color);
      } else if (isPlainObject(color)) {
        this.setColorFromObject(color);
      } else {
        throw new Error('Invalid input type');
      }
    }

    /**
     * Set color from an array.
     *
     * @private
     * @param {Array} input
     */

  }, {
    key: 'setColorFromArray',
    value: function setColorFromArray() {
      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isRequired('input');

      if (!Array.isArray(input)) throw new Error('input is not an array');

      this.rgb = {
        r: this.limit(input[0], 'r'),
        g: this.limit(input[1], 'g'),
        b: this.limit(input[2], 'b')
      };

      this.hex = this.rgb2hex();
      this.hsl = this.rgb2hsl();
    }

    /**
     * Set color from an object.
     *
     * @private
     * @param {Object} input
     */

  }, {
    key: 'setColorFromObject',
    value: function setColorFromObject() {
      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isRequired('input');

      if (!isPlainObject(input)) throw new Error('input is not an object');

      if (hasProperty(input, 'h') && hasProperty(input, 's') && hasProperty(input, 'l')) {
        this.hsl = {
          h: this.limit(input.h, 'h'),
          s: this.limit(input.s, 's'),
          l: this.limit(input.l, 'l')
        };
        this.rgb = this.hsl2rgb();
      } else if (hasProperty(input, 'r') && hasProperty(input, 'g') && hasProperty(input, 'b')) {
        this.rgb = input;
        this.hsl = this.rgb2hsl();
      } else {
        throw new Error('Invalid object');
      }

      this.hex = this.hsl2hex();
    }

    /**
     * Make the color lighter.
     *
     * @param {number} percentage
     * @returns {string}
     */

  }, {
    key: 'lighten',
    value: function lighten() {
      var percentage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

      var hsl = this.shift({
        l: this.constrain(this.lightness, percentage, [0, 100], '+')
      });

      return this.hsl2hex(hsl);
    }

    /**
     * Make the color darker.
     *
     * @param {number} percentage
     * @returns {string}
     */

  }, {
    key: 'darken',
    value: function darken() {
      var percentage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

      var hsl = this.shift({
        l: this.constrain(this.lightness, percentage, [0, 100], '-')
      });

      return this.hsl2hex(hsl);
    }

    /**
     * Increase saturation.
     *
     * @param {number} percentage
     * @returns {string}
     */

  }, {
    key: 'saturate',
    value: function saturate() {
      var percentage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

      var hsl = this.shift({
        s: this.constrain(this.saturation, percentage, [0, 100], '+')
      });

      return this.hsl2hex(hsl);
    }

    /**
     * Decrease saturation.
     *
     * @param {number} percentage
     * @returns {string}
     */

  }, {
    key: 'desaturate',
    value: function desaturate() {
      var percentage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

      var hsl = this.shift({
        s: this.constrain(this.saturation, percentage, [0, 100], '-')
      });

      return this.hsl2hex(hsl);
    }

    /**
     * Adjust the color hue.
     *
     * @param {number} degrees
     * @returns {string}
     */

  }, {
    key: 'adjustHue',
    value: function adjustHue() {
      var degrees = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 15;

      var hsl = this.shift({
        h: this.constrainDegrees(this.hue, +degrees)
      });

      return this.hsl2hex(hsl);
    }

    /**
     * Alter color values.
     *
     * @param {Object} input
     * @param {boolean} [returnHex]
     *
     * @returns {string}
     */

  }, {
    key: 'remix',
    value: function remix() {
      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isRequired('input');
      var returnHex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var shift = this.shift(input);

      if (returnHex) {
        return shift.r ? this.rgb2hex(shift) : this.hsl2hex(shift);
      }

      return shift;
    }

    /**
     * Generate a random color.
     *
     * @returns {{hex: string, rgb: Object, hsl: Object}}
     */

  }, {
    key: 'random',
    value: function random() {
      var hsl = {
        h: Math.floor(Math.random() * 360) + 1,
        s: Math.floor(Math.random() * 90) + 10,
        l: Math.floor(Math.random() * 80) + 10
      };

      return {
        hex: this.hsl2hex(hsl),
        rgb: this.hsl2rgb(hsl),
        hsl: hsl
      };
    }

    /**
     * Get the contrasted color for a given hex.
     *
     * @param {string} input
     * @returns {string}
     */

  }, {
    key: 'textColor',
    value: function textColor() {
      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.hex;

      var _hex2rgb = this.hex2rgb(input),
          r = _hex2rgb.r,
          g = _hex2rgb.g,
          b = _hex2rgb.b;

      var yiq = (r * 299 + g * 587 + b * 114) / 1000;

      return yiq >= 128 ? '#000' : '#fff';
    }

    /**
     * Test 2 colors for compliance.
     *
     * @param {Object} left
     * @param {Object} [right]
     * @returns {Object}
     */

  }, {
    key: 'checkContrast',
    value: function checkContrast() {
      var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isRequired('left');
      var right = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.hex;

      var LuminanceLeft = this.getLuminance(left);
      var LuminanceRight = this.getLuminance(right);
      var colorDifference = this.getColorDifference(left, right);
      var colorThreshold = 500;
      var brightnessDifference = this.getBrightnessDifference(left, right);
      var brightnessThreshold = 125;
      var ratio = 1;

      if (LuminanceLeft >= LuminanceRight) {
        ratio = (LuminanceLeft + 0.05) / (LuminanceRight + 0.05);
      } else {
        ratio = (LuminanceRight + 0.05) / (LuminanceLeft + 0.05);
      }

      ratio = round(ratio, 4);

      var isBright = brightnessDifference >= brightnessThreshold;
      var hasEnoughDifference = colorDifference >= colorThreshold;

      var compliant = 0;

      if (isBright && hasEnoughDifference) {
        compliant = 2;
      } else if (isBright || hasEnoughDifference) {
        compliant = 1;
      }

      return {
        brightnessDifference: brightnessDifference,
        colorDifference: colorDifference,
        compliant: compliant,
        contrastRatio: ratio,
        w2a: ratio >= 3,
        w2aaab: ratio >= 7,
        w2aaaa: ratio >= 4.5,
        w2b: ratio >= 4.5
      };
    }

    /**
     * Get the brightness difference between 2 colors.
     *
     * @param {Object} left
     * @param {Object} [right]
     * @returns {number}
     */

  }, {
    key: 'getBrightnessDifference',
    value: function getBrightnessDifference() {
      var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isRequired('left');
      var right = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.hex;

      var RGBLeft = this.hex2rgb(left);
      var RGBRight = this.hex2rgb(right);

      var rightY = (RGBRight.r * 299 + RGBRight.g * 587 + RGBRight.b * 114) / 1000;
      var leftY = (RGBLeft.r * 299 + RGBLeft.g * 587 + RGBLeft.b * 114) / 1000;
      return round(Math.abs(rightY - leftY), 4);
    }

    /**
     * Get the color difference between 2 colors.
     *
     * @param {Object} left
     * @param {Object} [right]
     * @returns {number}
     */

  }, {
    key: 'getColorDifference',
    value: function getColorDifference() {
      var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isRequired('left');
      var right = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.hex;

      var RGBLeft = this.hex2rgb(left);
      var RGBRight = this.hex2rgb(right);

      return Math.max(RGBLeft.r, RGBRight.r) - Math.min(RGBLeft.r, RGBRight.r) + (Math.max(RGBLeft.g, RGBRight.g) - Math.min(RGBLeft.g, RGBRight.g)) + (Math.max(RGBLeft.b, RGBRight.b) - Math.min(RGBLeft.b, RGBRight.b));
    }

    /**
     * Get the luminance of a color.
     *
     * @param hex
     * @returns {number}
     */

  }, {
    key: 'getLuminance',
    value: function getLuminance() {
      var hex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.hex;

      var rgb = this.hex2rgb(hex);

      rgb = [rgb.r / 255, rgb.g / 255, rgb.b / 255];

      for (var i = 0; i < rgb.length; i++) {
        if (rgb[i] <= 0.03928) {
          rgb[i] /= 12.92;
        } else {
          rgb[i] = Math.pow((rgb[i] + 0.055) / 1.055, 2.4);
        }
      }

      return round(0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2], 4);
    }

    /**
     * Parse HEX color.
     *
     * @param {string} input
     *
     * @returns {string}
     */

  }, {
    key: 'parseHex',
    value: function parseHex() {
      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isRequired('input');

      var color = input.replace('#', '');
      var hex = color;

      if (color.length === 3) {
        hex = '';

        color.split('').forEach(function (d) {
          hex += d + d;
        });
      }

      hex = '#' + hex;

      if (!validateHex(hex)) {
        throw new Error('Invalid color');
      }

      return hex;
    }

    /**
     * Parse CSS attribute.
     *
     * @param {string} input
     * @returns {Object}
     */

  }, {
    key: 'parseCSS',
    value: function parseCSS() {
      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isRequired('input');

      var model = /^rgb/.test(input) ? 'rgba' : 'hsla';
      var regex = new RegExp('^' + model + '?[\\s+]?\\([\\s+]?(\\d+)[\\s+]?,[\\s+]?(\\d+)[\\s+]?,[\\s+]?(\\d+)[\\s+]?', 'i');
      var matches = input.match(regex);

      if (matches && matches.length === 4) {
        var _ref;

        return _ref = {}, _defineProperty(_ref, model.slice(0, 1), parseInt(matches[1], 10)), _defineProperty(_ref, model.slice(1, 2), parseInt(matches[2], 10)), _defineProperty(_ref, model.slice(2, 3), parseInt(matches[3], 10)), _ref;
      }

      throw new Error('Invalid CSS string');
    }

    /**
     * Convert a hex string to RGB object.
     *
     * @param {string} [input]
     * @returns {{r: number, g: number, b: number}}
     */

  }, {
    key: 'hex2rgb',
    value: function hex2rgb() {
      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.hex;

      var hex = this.parseHex(input).substr(1);

      return {
        r: parseInt(String(hex.charAt(0)) + hex.charAt(1), 16),
        g: parseInt(String(hex.charAt(2)) + hex.charAt(3), 16),
        b: parseInt(String(hex.charAt(4)) + hex.charAt(5), 16)
      };
    }

    /**
     * Convert a hex string to HSL object.
     *
     * @param {string} [input]
     * @returns {{h: number, s: number, l: number}}
     */

  }, {
    key: 'hex2hsl',
    value: function hex2hsl() {
      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.hex;

      return this.rgb2hsl(this.hex2rgb(input));
    }

    /**
     * Convert a RGB object to HSL.
     *
     * @param {Object|string} [input]
     * @returns {{h: number, s: number, l: number}}
     */

  }, {
    key: 'rgb2hsl',
    value: function rgb2hsl() {
      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.rgb;

      var rgb = typeof input === 'string' ? this.parseCSS(input) : input;

      if (!hasProperty(rgb, 'r') || !hasProperty(rgb, 'g') || !hasProperty(rgb, 'b')) {
        throw new Error('Invalid object');
      }

      var r = this.limit(rgb.r, 'r') / 255;
      var g = this.limit(rgb.g, 'g') / 255;
      var b = this.limit(rgb.b, 'b') / 255;

      var min = Math.min(r, g, b);
      var max = Math.max(r, g, b);
      var delta = max - min;

      var h = 0;
      var s = void 0;
      var l = void 0;
      var rate = void 0;

      switch (max) {
        case r:
          rate = !delta ? 0 : (g - b) / delta;
          h = 60 * rate;
          break;
        case g:
          rate = (b - r) / delta;
          h = 60 * rate + 120;
          break;
        case b:
          rate = (r - g) / delta;
          h = 60 * rate + 240;
          break;
        /* istanbul ignore next */
        default:
          break;
      }

      if (h < 0) {
        h = 360 + h;
      }

      l = (max + min) / 2.0;

      if (min === max) {
        s = 0;
      } else {
        s = l < 0.5 ? delta / (2 * l) : delta / (2 - 2 * l);
      }

      return {
        h: Math.abs(+(h % 360).toFixed(2)),
        s: +(s * 100).toFixed(2),
        l: +(l * 100).toFixed(2)
      };
    }

    /**
     * Convert a RGA object to hex.
     *
     * @param {Object|string} [input]
     *
     * @returns {string}
     */

  }, {
    key: 'rgb2hex',
    value: function rgb2hex() {
      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.rgb;

      var rgb = typeof input === 'string' ? this.parseCSS(input) : input;

      if (!hasProperty(rgb, 'r') || !hasProperty(rgb, 'g') || !hasProperty(rgb, 'b')) {
        throw new Error('Invalid object');
      }

      var hex = (1 << 24) + (rgb.r << 16) + (rgb.g << 8) + rgb.b;

      return '#' + hex.toString(16).slice(1);
    }

    /**
     * Convert a HSL object to RGB.
     *
     * @param {Object|string} [input]
     * @returns {{r: number, g: number, b: number}}
     */

  }, {
    key: 'hsl2rgb',
    value: function hsl2rgb() {
      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.hsl;

      var hsl = typeof input === 'string' ? this.parseCSS(input) : input;

      if (!hasProperty(hsl, 'h') || !hasProperty(hsl, 's') || !hasProperty(hsl, 'l')) {
        throw new Error('Invalid object');
      }

      var h = round(hsl.h) / 360;
      var s = round(hsl.s) / 100;
      var l = round(hsl.l) / 100;

      var r = void 0;
      var g = void 0;
      var b = void 0;

      var point = void 0;
      var chroma = void 0;

      if (s === 0) {
        r = l;
        g = l;
        b = l;
      } else {
        chroma = l < 0.5 ? l * (1 + s) : l + s - l * s;
        point = 2 * l - chroma;

        r = this.hue2rgb(point, chroma, h + 1 / 3);
        g = this.hue2rgb(point, chroma, h);
        b = this.hue2rgb(point, chroma, h - 1 / 3);
      }

      return {
        r: Math.round(r * 255),
        g: Math.round(g * 255),
        b: Math.round(b * 255)
      };
    }

    /**
     * Convert a HSL object to HEX.
     *
     * @param {Object|string} [input]
     * @returns {string}
     */

  }, {
    key: 'hsl2hex',
    value: function hsl2hex() {
      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.hsl;

      var hsl = typeof input === 'string' ? this.parseCSS(input) : input;

      return this.rgb2hex(this.hsl2rgb(hsl));
    }

    /**
     * Convert hue to RGB using chroma and median point
     *
     * @private
     * @param {number} point
     * @param {number} chroma
     * @param {number} h
     *
     * @returns {*}
     */

  }, {
    key: 'hue2rgb',
    value: function hue2rgb() {
      var point = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isRequired('point');
      var chroma = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : isRequired('chroma');
      var h = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : isRequired('hue');

      var hue = h;

      if (hue < 0) {
        hue += 1;
      }

      if (hue > 1) {
        hue -= 1;
      }

      if (hue < 1 / 6) {
        return round(point + (chroma - point) * 6 * hue, 4);
      }

      if (hue < 1 / 2) {
        return round(chroma, 4);
      }

      if (hue < 2 / 3) {
        return round(point + (chroma - point) * (2 / 3 - hue) * 6, 4);
      }

      return round(point, 4);
    }

    /**
     * Get a shifted color object with the same model of the input.
     *
     * @private
     * @param {Object} input - {r,g,b} or {h,s,l}
     * @returns {Object}
     */

  }, {
    key: 'shift',
    value: function shift() {
      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isRequired('input');

      if (!isPlainObject(input)) {
        throw new Error('Invalid input');
      }

      var isHSL = Object.keys(input).some(function (d) {
        return HSL.indexOf(d) !== -1;
      });
      var isRGB = Object.keys(input).some(function (d) {
        return RGB.indexOf(d) !== -1;
      });

      if (isRGB && isHSL) {
        throw new Error('Use a single color model');
      }

      if (!isHSL && !isRGB) {
        throw new Error('Could not match a color model');
      }

      if (isHSL) {
        var hsl = pick(input, HSL);

        return _extends({}, this.hsl, hsl);
      }

      // Not HSL so it must be RGB
      var rgb = pick(input, RGB);

      return _extends({}, this.rgb, rgb);
    }

    /**
     * Limit values per type.
     *
     * @private
     * @param {number} input
     * @param {string} type
     * @returns {number}
     */

  }, {
    key: 'limit',
    value: function limit() {
      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isRequired('input');
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : isRequired('type');

      if (typeof input !== 'number') {
        throw new Error('Input is not a number');
      }

      /* istanbul ignore else */
      if (RGB.indexOf(type) !== -1) {
        return Math.max(Math.min(input, 255), 0);
      } else if (['s', 'l'].indexOf(type) !== -1) {
        return Math.max(Math.min(input, 100), 0);
      } else if (type === 'h') {
        return Math.max(Math.min(input, 360), 0);
      }

      throw new Error('Invalid type');
    }

    /**
     * Constrain value into the range
     *
     * @private
     * @param {number} input
     * @param {number} amount
     * @param {Array} range
     * @param {string} sign
     * @returns {number}
     */

  }, {
    key: 'constrain',
    value: function constrain() {
      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isRequired('input');
      var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : isRequired('amount');
      var range = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : isRequired('range');
      var sign = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : isRequired('sign');

      var _range = _slicedToArray(range, 2),
          min = _range[0],
          max = _range[1];

      var value = expr(input + sign + amount);

      if (value < min) {
        value = min;
      } else if (value > max) {
        value = max;
      }

      return Math.abs(value);
    }

    /**
     * Constrain an angle
     *
     * @private
     * @param {number} input
     * @param {number} amount
     * @returns {number}
     */

  }, {
    key: 'constrainDegrees',
    value: function constrainDegrees() {
      var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isRequired('input');
      var amount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : isRequired('amount');

      var value = input + amount;

      if (value > 360) {
        value -= 360;
      }

      if (value < 0) {
        value += 360;
      }

      return Math.abs(value);
    }

    /**
     * @type {number}
     */

  }, {
    key: 'red',
    get: function get() {
      return Number(this.rgb.r);
    }

    /**
     * @type {number}
     */

  }, {
    key: 'green',
    get: function get() {
      return Number(this.rgb.g);
    }

    /**
     * @type {number}
     */

  }, {
    key: 'blue',
    get: function get() {
      return Number(this.rgb.b);
    }

    /**
     * @type {number}
     */

  }, {
    key: 'hue',
    get: function get() {
      return Number(this.hsl.h);
    }

    /**
     * @type {number}
     */

  }, {
    key: 'saturation',
    get: function get() {
      return Number(this.hsl.s);
    }

    /**
     * @type {number}
     */

  }, {
    key: 'lightness',
    get: function get() {
      return Number(this.hsl.l);
    }
  }]);

  return Colorizr;
}();

export { validateHex };

export default Colorizr;


//////////////////
// WEBPACK FOOTER
// ../node_modules/colorizr/es/index.js
// module id = 239
// module chunks = 0